import React, { useState } from "react";
import { Button } from "antd";
import "./style.scss";
import { AddEditMaterialsForm } from "../AddEditMaterials";

const ActionHeader = ({ onSubmitSuccess, onFieldSelected }: any) => {
   const [showAddEditForm, setShowAddEditForm] = useState(false);
   const handleShowAddEditForm = () => {
      setShowAddEditForm(true);
   };
   const handleAddEditFormCancelEvent = () => {
      setShowAddEditForm(false);
   };

   const handleAddEditFormSubmitEvent = () => {
      setShowAddEditForm(false);
   };

   return (
      <>
         <div className="action-header-wrapper">
            <Button type="primary" size="large" onClick={handleShowAddEditForm}>
               Add Material
            </Button>
         </div>
         {showAddEditForm && (
            <AddEditMaterialsForm
               onSubmitSuccess={onSubmitSuccess}
               showForm={showAddEditForm}
               onSubmit={handleAddEditFormSubmitEvent}
               onCancel={handleAddEditFormCancelEvent}></AddEditMaterialsForm>
         )}
      </>
   );
};

export default ActionHeader;
